module.exports = __webpack_public_path__ + "img/card_header_help_layouts.29e222d0.jpg";